import React from 'react';

const ItemRow = ({ name, unit, quantityValue, onQuantityChange }) => {
  return (
    <div className="row mb-2 align-items-center bg-white px-2 py-2"  style={{ borderRadius: '10px' }}>
      <div className="col-md-4 text-primary fw-bold fs-6">{name}</div>
      <div className="col-md-3">
        {/* <input type="text" className="form-control" placeholder="Enter Quantity" /> */}
        <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        className="form-control"
        maxLength={6}
        value={quantityValue}
        onChange={onQuantityChange}
      />
      </div>
      <div className="col-md-3 text-primary font-w500">{unit}</div>
    </div>
  );
};

export default ItemRow;
